export default __webpack_public_path__ + "static/media/australia.7832eac2.png";